const zh = {
  officialPrice: "官方指导价",
  price: "价格",
  quantity: '数量',
  buyNow: "立即购买",
  addToCart: "加入购物车",
  productDetail: '商品详情',
  product: '商品',
  brand: '品牌',
  productName: '商品名称',
  unit: '单位',
  specification: '规格',
  specificationNum: '规格数',
  description: '描述',
  tips: '提示',
  dataLoadFailed: '数据加载失败，请稍后再试',
  confirm: '确定',
  quantityLessThanOne: '商品数量不可少于1',
  addToCartSuccess: '加入购物车成功',
  addToCartFailed: '加入购物车失败',
  buyQuantity: '购买数量',
};
export default zh;
